import { Provider } from '@angular/core'
import { BiddingService } from 'game-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from 'shared-components'

export const biddingServiceProvider: Provider = {
  provide: BiddingService,
  useFactory: (gamePlayConfig: GamePlayConfig): BiddingService => {
    return new BiddingService(gamePlayConfig)
  },
  deps: [gamePlayConfigToken],
}
